const block_icons     = {
    advace_child_icon:    <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    enableBackground="new 0 0 512 512"
    viewBox="0 0 24 24"
  >
    <g fill="#cb1d1d">
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M0 18v5a1 1 0 001 1h5a1 1 0 001-1v-5a1 1 0 00-1-1H1a1 1 0 00-1 1zM6 0H1a1 1 0 00-1 1v13.5a1 1 0 001 1h5a1 1 0 001-1V1a1 1 0 00-1-1zM15.5 14.5V1a1 1 0 00-1-1h-5a1 1 0 00-1 1v13.5a1 1 0 001 1h5a1 1 0 001-1zM8.5 18v5a1 1 0 001 1h5a1 1 0 001-1v-5a1 1 0 00-1-1h-5a1 1 0 00-1 1zM23 0h-5a1 1 0 00-1 1v13.5a1 1 0 001 1h5a1 1 0 001-1V1a1 1 0 00-1-1zM18 24h5a1 1 0 001-1v-5a1 1 0 00-1-1h-5a1 1 0 00-1 1v5a1 1 0 001 1z"
        data-original="#000000"
      ></path>
    </g>
  </svg>
}

export default block_icons;